export const NODE_VALIDATION_FIELD_ID = '_node'
export const HANDLE_VALIDATION_FIELD_PREFIX = '_handle'

/**
 * Key under which workflow-level (whole-design) validation results are stored
 * in `ValidationResults`, sitting alongside the per-node entries. Used for
 * checks that are not tied to a single node — e.g. whether the design is our
 * inert no-op workflow.
 */
export const WORKFLOW_VALIDATION_KEY = 'workflow'
export const WORKFLOW_VALIDATION_NOOP_FIELD = 'noop'
